<template>
  <div class="Rtable-row">
    <div class="Rtable-cell cb-cell">
      <div class="Rtable-cell--heading">Select</div>
      <!--      <div class="Rtable-cell&#45;&#45;content date-content"><span class="webinar-date">August 2nd, 2016</span><br />6:00 pm (CDT)</div>-->
      <div class="Rtable-cell--content date-content">
        <input type="checkbox" />
      </div>
    </div>
    <div class="Rtable-cell img-cell">
      <div class="Rtable-cell--heading">Image</div>
      <div class="Rtable-cell--content title-content">
        <img
            v-if="item.img"
            :src="item.img"
            alt=""
            class="img-thumbnail profile-image"
        />
        <i v-if="!item.img" class="fas fa-user-circle"></i>
      </div>
    </div>
    <div class="Rtable-cell company-cell">
      <div class="Rtable-cell--heading">Company</div>
      <div class="Rtable-cell--content title-content">{{ item.company_id }}</div>
    </div>
    <div class="Rtable-cell description-cell">
      <div class="Rtable-cell--heading">Name</div>
      <div class="Rtable-cell--content access-link-content">{{ item.description }}</div>
    </div>
    <div class="Rtable-cell price-cell">
      <div class="Rtable-cell--heading">SMS</div>
      <div class="Rtable-cell--content replay-link-content">{{ item.price }}</div>
    </div>
    <div class="Rtable-cell quantity-cell">
      <div class="Rtable-cell--heading">Phone</div>
      <div class="Rtable-cell--content replay-link-content">{{ item.quantity }}</div>
    </div>
    <div class="Rtable-cell user-cell">
      <div class="Rtable-cell--heading">Email</div>
      <div class="Rtable-cell--content replay-link-content">{{ item.user_id }}</div>
    </div>
    <div class="Rtable-cell country-cell">
      <div class="Rtable-cell--heading">Country</div>
      <div class="Rtable-cell--content replay-link-content">{{ item.country_id }}</div>
    </div>
    <div class="Rtable-cell plus-cell">
      <div class="Rtable-cell--heading">Plus</div>
      <div class="Rtable-cell--content replay-link-content">
        <ContactAddTag />
      </div>
    </div>
    <div class="Rtable-cell Rtable-cell--foot tags-cell">
      <div class="Rtable-cell--heading">Tags</div>
      <div class="Rtable-cell--content pdf-content">
        <ContactTags :tags="[{ data:{}, tagType: 'new'}, { data:{}, tagType: 'sc'}, { data:{}, tagType: 'na'}]" :tagSector="'contacts'"/>     <!-- Contact tabs container get object of tags  || TODO make sector dynamic(probably from url) -->
      </div>
    </div>
  </div>
</template>

<script>
import ContactTags from "@/features/projects.feature/contacts/containers/ContactTags.container";
import ContactAddTag from "@/features/projects.feature/contacts/components/ContactAddTag.component";
export default {
  name: "Contact",
  components: { ContactAddTag, ContactTags },
  props: {
    item: {
      type: Object
    },
    columnSize: {
      type: Object
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
$breakpoint: 750px;
$heading-color: #43bac0;

* {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  //max-width: 1000px;
  //margin: 1em auto;
  //padding: 1em;
}

.is-striped {
  background-color: rgba(233, 200, 147, 0.2);
}

/* Table column sizing
================================== */
/* Table column sizing
================================== */
.cb-cell {
  width: 3%;
}
.img-cell{
  width: 3%;
}
.company-cell {
  width: 7%;
}
.description-cell {
  width: 13%;
}
.price-cell {
  width: 5%;
}
.quantity-cell {
  width: 5%;
}
.user-cell {
  width: 7%;
}
.country-cell {
  width: 5%;
}
.plus-cell {
  width: 3%;
}
.tags-cell {
  width: 50%;
}

/* Apply styles
================================== */
.Rtable {
  display: flex;
  flex-wrap: wrap;
  //margin: 0 0 3em 0;
  padding: 0;
  //box-shadow: 0 0 40px rgba(0,0,0,0.2);

  .Rtable-row {
    width: 100%;
    display: flex;

    .Rtable-cell {
      box-sizing: border-box;
      flex-grow: 1;
      //padding: 0.8em 1.2em;
      padding: 0.26%;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        background-color: $heading-color;
        color: white;
        padding: 1em;
      }

      .Rtable-cell--heading {
        display: none;
      }

      .Rtable-cell--content {
        a {
          font-size: 2em;
          color: #333;
        }

        .webinar-date {
          font-weight: 700;
        }
      }
    }
  }
}

/* Responsive
==================================== */
@media all and (max-width: $breakpoint) {
  .is-striped {
    background-color: white;
  }

  .Rtable--collapse {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .Rtable-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

      .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;

        .Rtable-cell--heading {
          display: inline-block;
          flex: 1;
          max-width: 120px;
          min-width: 120px;
          color: $heading-color;
          font-weight: 700;
          border-right: 1px solid #ccc;
          margin-right: 1em;
        }

        .Rtable-cell--content {
          flex: 2;
          padding-left: 1em;
        }
      }
    }

    .topic-cell {
      background-color: $heading-color;
      color: white;
      font-weight: 700;
      order: -1;

      .Rtable-cell--content {
        padding-left: 0 !important;
      }
    }

    .Rtable-row--head {
      display: none;
    }
  }
}

// Non-Flex modernizer fallback
.no-flexbox .Rtable {
  display: block;

  &.Rtable-cell {
    width: 100%;
  }
}
.Rtable-row{
  //min-height: 325px;
  max-height: 50px;

}
.profile-image{
  border-radius: 20%;
  height: 40px;
  width: 40px;
}
.img-cell .fa-user-circle{
  font-size: 35px;
  margin-left: 2px;
}
</style>
